module.exports = __webpack_public_path__ + "static/jiyajia-5bcd8635b9658f6974adf780fb2b38dc.jpg";